<template lang="pug">
.v-tabs-request.tabs-request(v-if="tabsData")
	//h2.tabs-request__title(v-if='tabsData.title') {{tabsData.title}}
	.tabs-request__tabs(:class='tabsData.addClass')
		.tabs-request__prefix(v-if="tabsData.prefix" ) {{ tabsData.prefix }}:
		template(v-for="(tab, tabIndex) in tabsData.tabs" :key="tabIndex")
			template(v-if="tab.link")
				.tabs-request__item
					a.tabs-request__action(:class="{'active': currentTabIndex === tabIndex}"
						:href="tab.link"
						:target="getLinkTarget(tab.link)")
						| {{`${tab.name} ${tab.number || tab.number === 0 ? `(${tab.number})` : ''}`}}
			template(v-else)
				.tabs-request__item
					button.tabs-request__action(:class="{'active': currentTabIndex === tabIndex}"
						type="button"
						@click="currentTabIndex = tabIndex")
						| {{`${tab.name} ${tab.number || tab.number === 0 ? `(${tab.number})` : ''}`}}
	.tabs-request__content-wrap
		template(v-if="tabsData.type === 'slots'")
			template(v-for="(tab, tabIndex) in tabsData.tabs" :key="tabIndex")
				.tabs-request__content(v-if="currentTabIndex === tabIndex" :class="tab.contentClassName")
					slot(:name="tab.slotName" :content="tab.content")
		template(v-if="tabsData.type === 'html'")
			template(v-for="(tab, tabIndex) in tabsData.tabs" :key="tabIndex")
				.tabs-request__content.text-guide(v-if="currentTabIndex === tabIndex" v-html="tab.content" :class="tab.contentClassName")
</template>

<script>

import sourceMixin from '../components/mixins/v-mixin-source.vue';
import isMobMixin from '../components/mixins/v-mixin-is-mob.vue';
import linkTargetMixin from '../components/mixins/v-mixin-link-target.vue';

export default {
	mixins: [
		sourceMixin,
		isMobMixin,
		linkTargetMixin
	],

	data() {
		return {
			currentTabIndex: 0,
			tabsData: null
		};
	},

	methods: {
		dataSet(data) {
			this.tabsData = data;
			const currentTabIndex = this.tabsData.tabs.findIndex(item => item.active);
			if (currentTabIndex > -1) {
				this.currentTabIndex = currentTabIndex;
			}
		}
	}
};
</script>